import ramdaMergeDeepRight from 'ramda/src/mergeDeepRight';

import { DeepPartial } from '@/types/commom';

export const merge = <T extends object = object>(target: T, ...sources: Array<T | DeepPartial<T>>): T => {
  const result = sources.reduce<T>((prev, next) => ramdaMergeDeepRight(prev, next) as unknown as T, target);

  return result;
};
